import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { GAME_QUERY } from '../../gql/queries/game';
import { service } from '@ember/service';

export default class Game extends Route {
  @service head;

  async model({ slug }) {
    try {
      this.query = useQuery(this, () => [
        GAME_QUERY,
        { variables: { slug } },
      ]);

      await this.query.promise;
      return this.query.data?.game || null;
    } catch (error) {
      console.error('Error loading game:', error);
      return null;
    }
  }

  afterModel(model) {
    if (model) {
      this.head.updateMeta({
        title: model.name,
        description: model.description,
        ogTitle: model.name,
        ogDescription: model.description,
        ogImage: model.logo?.url,
        canonical: `https://1vX.gg/games/${model.slug}`
      });
    }
  }
}
